const rankingItems = [
  {
    rank: 1,
    title: '红桃视频 · 最新热播电视剧全集',
    tag: '电视剧',
   热度: '986万',
    platform: '红桃视频',
  },
  {
    rank: 2,
    title: '樱桃视频 · 高分悬疑剧精选合集',
    tag: '悬疑',
   热度: '875万',
    platform: '樱桃视频',
  },
  {
    rank: 3,
    title: '茄子视频 · 热门短剧日更系列',
    tag: '短剧',
   热度: '762万',
    platform: '茄子视频',
  },
  {
    rank: 4,
    title: '糖心视频 · 爆款综艺最新季',
    tag: '综艺',
   热度: '698万',
    platform: '糖心视频',
  },
  {
    rank: 5,
    title: '红桃视频 · 古装剧年度盘点',
    tag: '古装',
   热度: '621万',
    platform: '红桃视频',
  },
  {
    rank: 6,
    title: '樱桃视频 · 都市情感剧热播榜',
    tag: '都市',
   热度: '543万',
    platform: '樱桃视频',
  },
  {
    rank: 7,
    title: '茄子视频 · 周末电影精选特辑',
    tag: '电影',
   热度: '489万',
    platform: '茄子视频',
  },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1)
      return 'bg-accent-500 text-background-50';
    if (rank === 2)
      return 'bg-primary-500 text-background-50';
    if (rank === 3)
      return 'bg-secondary-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            实时更新全网热门视频内容排行，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="space-y-3">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-4 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div
                  className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-extrabold flex-shrink-0 ${getRankStyle(
                    item.rank
                  )}`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.platform}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                  <span className="text-sm font-bold text-accent-600 whitespace-nowrap">{item.热度}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}